import { FC, useState } from "react";

import Colors from "@constants/Colors";
import { ReactComponent as PopupIcon } from "@icons/down-arrow-icon.svg";
import { MenuItem } from "@mui/material";

import { StyledDropdown, StyledFormControl } from "./style";

interface CustomSelectInputProps {
  handleChange: (type: string) => void;
  value: string;
  options: string[];
}

const CustomSelectInput: FC<CustomSelectInputProps> = ({
  handleChange,
  value,
  options,
}) => {
  const [open, setOpen] = useState(false);
  const toggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <StyledFormControl size="medium">
      <StyledDropdown
        value={value}
        MenuProps={{
          MenuListProps: {
            disablePadding: true,
          },
          PaperProps: {
            style: {
              border: `1px solid ${Colors.neutral_gray_300}`,
              padding: "0px !important",
              borderRadius: "8px",
              boxShadow: Colors.Elevation_4,
            },
          },
        }}
        sx={{
          backgroundColor: open ? Colors.primary_800 : Colors.white,
          " & .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input": {
            color: open
              ? `${Colors.white}  !important`
              : `${Colors.secondary} !important`,
          },

          "& .MuiSelect-icon": {
            filter: open
              ? "invert(100%) sepia(53%) saturate(0%) hue-rotate(108deg) brightness(1000%) contrast(100%)"
              : "invert(23%) sepia(58%) saturate(645%) hue-rotate(195deg) brightness(64%) contrast(88%)",
          },
        }}
        IconComponent={PopupIcon}
        onChange={(event) => {
          handleChange(event.target.value as string);
        }}
        displayEmpty
        inputProps={{ "aria-label": "Filter Type" }}
        onOpen={toggle}
        onClose={toggle}
      >
        {options?.map((option) => (
          <MenuItem
            key={option}
            value={option}
            sx={{
              "&.Mui-selected": {
                backgroundColor: Colors.neutral_gray_100,
                color: Colors.primary,
              },
              "&:focus": {
                backgroundColor: `${Colors.neutral_gray_100} !important`,
              },
            }}
          >
            {option}
          </MenuItem>
        ))}
      </StyledDropdown>
    </StyledFormControl>
  );
};

export default CustomSelectInput;
